export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i += 1) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const PRESET_LABEL_COLORS = [
  '#EF4444', // Vermelho
  '#F97316', // Laranja
  '#EAB308', // Amarelo
  '#22C55E', // Verde
  '#14B8A6', // Teal
  '#3B82F6', // Azul
  '#6366F1', // Índigo
  '#A855F7', // Roxo
  '#EC4899', // Rosa
  '#F43F5E', // Rosa-avermelhado
  '#78716C', // Marrom acinzentado
  '#6B7280', // Cinza
  '#9CA3AF', // Cinza claro
  '#374151', // Cinza escuro
  '#111827', // Quase preto
  '#FFFFFF', // Branco
];
